export const SHOW_PLAID_INFO_MESSAGE = 'PLAID/SHOW_PLAID_INFO_MESSAGE';

export const setIsPlaidInfoMessageVisibility = (payload: boolean) => ({
  type: SHOW_PLAID_INFO_MESSAGE,
  payload,
});
